



































































import { defineComponent, reactive, toRefs, onMounted, computed, onBeforeUnmount, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import SaitenEditTab from "../../components/SaitenEditTab.vue"
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import { BaseSheet, BaseSheetField }from  "../../modules/teacher/FieldEdit"

export interface Data {
  tabNo: number;
  base_sheet_id: string;
  baseSheet: BaseSheet | null;
  baseSheetFields: BaseSheetField[];
  errors: string[];
  isChangeSheetFields: boolean;
  SheetTypeEnum: Readonly<{Report: number; LessonKyouzai: number; LessonTest: number;}>
}

export default defineComponent({
  components: {
    "saiten-edit-tab": SaitenEditTab,
    "drop-area": DropArea,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      tabNo: 1,
      base_sheet_id: "",
      baseSheet: null,
      baseSheetFields: new Array<BaseSheetField>(),
      errors: [],
      isChangeSheetFields: false,
      SheetTypeEnum: Common.SheetTypeEnum,
    });

    /************************************************************
     * 種別が設問のリスト
     ************************************************************/

    const questionBaseSheetFields = computed(() => {
      return state.baseSheetFields.filter(x => x.kind == Common.SheetFieldKindEnum.FIELD);
    });

    /************************************************************
     * 合計点
     ************************************************************/

    const totalAllot = computed(() => {
      return Common.sumArray(state.baseSheetFields.filter(x => x.kind == Common.SheetFieldKindEnum.FIELD).map(x => typeof x.allot === "string" ? parseInt(x.allot) : x.allot));
    });

    /************************************************************
     * テンプレートダウンロード
     ************************************************************/

    const downloadFieldTemplate = async (): Promise<void> => {
      window.location.href = `/api/teacher/field_edit/download_field_template/${context.root.$store.state.sheet_type}`;
    };

    /************************************************************
     * 提出済みレポート有無チェック
     ************************************************************/

    const checkExistsSheet = async () => {
      
      state.errors = [];

      let is_exists_sheet = false;

      // 提出済みレポート有無を検索
      await http.get(`/api/teacher/field_edit/is_exists_sheet/${state.base_sheet_id}`).then(response => {
        is_exists_sheet = response.data.is_exists_sheet;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      return is_exists_sheet;
    }
    
    /************************************************************
     * エクセルアップロード
     ************************************************************/

    const upload = async (file: any) => {
      
      state.errors = [];

      if(await checkExistsSheet()){
        state.errors.push("既に提出済みの答案が存在するため、エクセルのアップロードはできません。");
      }

      if(state.errors.length > 0){
        return;
      }

      let fd = new FormData();
      fd.append('upload[file]', file);

      if(!window.confirm("ファイルをアップロードします。\n実行してよろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay", "ファイル読み込み中");

      const methodName = context.root.$store.state.sheet_type == Common.SheetTypeEnum.LessonKyouzai ? "upload_kyouzai" : "upload"

      await http.post(`/api/teacher/field_edit/${methodName}/${state.base_sheet_id}`, fd).then(response => {
        state.baseSheet = response.data.base_sheet;
        state.baseSheetFields = response.data.base_sheet_fields.map((x: any) => new BaseSheetField(x));

        alert("アップロードが完了しました。");
        state.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 保存
     ************************************************************/

    const saveClick = async () => {

      state.errors = [];

      if(await checkExistsSheet() && state.baseSheetFields.filter(x => x.allot != x.allot_cache || x.scoring_type != x.scoring_type_cache).length > 0){
        state.errors.push("提出済みの答案が存在するため、配点・採点方式の変更はできません。");
      }

      if(state.errors.length > 0){
        return;
      }

      if(!window.confirm("問題構造を保存します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay", "ファイル読み込み中");
      
      const url = context.root.$store.state.sheet_type == Common.SheetTypeEnum.LessonKyouzai ? `/api/teacher/field_edit/update_kyouzai/${state.base_sheet_id}` : `/api/teacher/field_edit/update/${state.base_sheet_id}`;

      await http.post(url, {base_sheet_fields: questionBaseSheetFields.value, is_change_sheet_fields: state.isChangeSheetFields}).then(response => {
        alert("処理が完了しました。");
        context.root.$router.push(`/teacher_site/correct_image_upload/${state.base_sheet_id}`).catch(err => {});
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 設問追加削除
     ************************************************************/

    const addSheetFields = (idx: number): void => {

      if (!window.confirm(`設問を追加します。\n既に採点情報が存在する場合、保存ボタン押下時に採点情報は削除されます。\n実行してよろしいですか？`)) {
        return;
      }

      state.isChangeSheetFields = true;

      // 設問追加
      const questionBaseSheetFields = state.baseSheetFields.filter(x => x.kind == 0);
      questionBaseSheetFields.splice(idx, 0, new BaseSheetField({id: 0, kind: 0, part1: null, part2: null, part3: null, allot: 0, page: 1}));

      state.baseSheetFields = state.baseSheetFields.filter(x => x.kind != 0).concat(questionBaseSheetFields);
    };

    const removeSheetFields = (idx: number): void => {

      if (!window.confirm(`設問を削除します。\n既に採点情報が存在する場合、保存ボタン押下時に採点情報は削除されます。\n実行してよろしいですか？`)) {
        return;
      }

      state.isChangeSheetFields = true;

      // 設問削除
      const questionBaseSheetFields = state.baseSheetFields.filter(x => x.kind == 0);
      questionBaseSheetFields.splice(idx, 1);

      state.baseSheetFields = state.baseSheetFields.filter(x => x.kind != 0).concat(questionBaseSheetFields);
    };

    /************************************************************
     * onMounted
     ************************************************************/

    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.base_sheet_id = context.root.$route.params.base_sheet_id;

      // APIで登録済みレポート情報取得
      await http.get(`/api/teacher/field_edit?base_sheet_id=${state.base_sheet_id}`).then(response => {
        context.root.$store.commit("setScoringSettingSheetType", response.data.base_sheet.sheet_type);
        state.baseSheet = response.data.base_sheet;
        state.baseSheetFields = response.data.base_sheet_fields.map((x: any) => new BaseSheetField(x));
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`レポート情報の取得処理に失敗しました。一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`レポート情報の取得処理に失敗しました。一覧に戻ります。`);
        }
        context.root.$store.dispatch("goBaseSheetList");
      });

      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      questionBaseSheetFields,
      totalAllot,
      downloadFieldTemplate,
      upload,
      saveClick,
      addSheetFields,
      removeSheetFields,
      checkExistsSheet,
    };
  }
})
